module.exports = __webpack_public_path__ + "img/join4-1-h.7418b6ba.svg";